<template>
  <div class="card card-custom card-stretch mb-5">
    <div class="card-header align-items-center border-0 mt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder text-dark fs-3">
          Выручка компании
        </span>
      </h3>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-lg-6">
          <apexchart
            :options="revenueOptions"
            :series="revenueSeries"
            height="200"
            type="bar"
          />
        </div>

        <div class="col-lg-6">
          <apexchart
            :options="projectedRevenueOptions"
            :series="projectedRevenueSeries"
            height="200"
            type="bar"
          />
        </div>
      </div>

      <div class="d-flex flex-row justify-content-between">
        <div>
          <span class="fw-bolder text-gray-800">
            Фактическая
          </span>
          <span class="w-25px h-5px d-block rounded mt-1" v-bind:style="{backgroundColor: '#22d48a'}"></span>
        </div>

        <div class="mx-3">
              <span class="fw-bolder text-gray-800">
                Текущая
              </span>
          <span class="w-25px h-5px d-block rounded mt-1" v-bind:style="{backgroundColor: '#fec703'}"></span>
        </div>

        <div>
          <span class="fw-bolder text-gray-800">
            Прогнозная
          </span>
          <span class="w-25px h-5px d-block rounded mt-1" v-bind:style="{backgroundColor: '#E4E6EF'}"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {year} from "../helpers/year";
import {cloneDeep, merge} from "lodash";

export default {
  props: {
    statistic: Array,
  },

  data() {
    const revenue = []
    const projectedRevenue = []
    let revenueMax = 0
    let projectedRevenueMax = 0

    this.statistic.forEach(v => {
      if (v.projected_revenue > 0 && v.year >= year) {
        projectedRevenue.push({
          x: v.year.toString(),
          y: v.projected_revenue,
          fillColor: '#E4E6EF',
        })
        projectedRevenueMax = Math.max(projectedRevenueMax, v.projected_revenue)
      }

      if (v.revenue === 0) {
        return
      }

      const bar = {
        x: v.year.toString(),
        y: v.revenue,
        fillColor: '#20D489',
      }

      if (v.year === year) {
        bar.fillColor = '#FFC700'
      }

      revenue.push(bar)

      revenueMax = Math.max(revenueMax, v.revenue)
    });

    const revenueSeries = [
      {
        name: "Выручка",
        data: revenue,
      },
    ];

    const projectedRevenueSeries = [
      {
        name: "Прогноз",
        data: projectedRevenue,
      }
    ];

    const revenueOptions = {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false
        },
      },
      plotOptions: {
        bar: {
          distributed: false,
          horizontal: false,
          columnWidth: ["80%"],
          borderRadius: 4,
        },
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        // categories: years,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          style: {
            colors: "#A1A5B7",
            fontSize: "12px"
          }
        }
      },
      yaxis: {
        max: Math.ceil(revenueMax / 500000000) * 500000000,
        tickAmount: 3,
        labels: {
          style: {
            colors: "#A1A5B7",
            fontSize: "12px"
          },
          formatter: v => {
            return (Math.round(v / 1000000000 * 100) / 100).toFixed(2) + ' млрд ₽'
          }
        },
      },
      fill: {
        opacity: 1
      },
      // colors: ["#20D489", "#E4E6EF"],
      tooltip: {
        style: {
          fontSize: "12px"
        },
      },
      grid: {
        borderColor: "#EFF2F5",
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true
          }
        }
      }
    }

    const projectedRevenueOptions = merge(cloneDeep(revenueOptions), {
      yaxis: {
        max: Math.ceil(projectedRevenueMax / 500000000) * 500000000,
      },
    })

    return {
      revenueOptions,
      revenueSeries,
      projectedRevenueOptions,
      projectedRevenueSeries,
    }
  },
}
</script>
